import { all, put, takeLatest } from "redux-saga/effects";

import store from "../../store/store";
import {
  hideLoader,
  showLoader,
} from "../../component-lib/Molecules/loader/LoaderSlice";
import { eventEHRCustomToastMessage } from "../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";
import {
  componentKey,
  setInventoryReport,
  setIncidentReport,
  setUsageReport,
  setDailyOrdersReport,
  setEmsDailyReport,
  setFacilityPatientHistoryReport,
  setIcdReport,
  setProviderPatientLog,
} from "./ReportsSlice";
import ReportsService from "../../services/ReportsService";

export const {
  getInventoryReport,
  getIncidentReport,
  getUsageReport,
  getDailyOrdersReport,
  getEmsDailyReport,
  getFacilityPatientHistoryReport,
  getIcdReport,
  getProviderPatientLog,
} = {
  getInventoryReport: (payload) => ({
    type: "REPORTS/GET_INVENTORY_REPORT",
    payload,
  }),
  getFacilityPatientHistoryReport: (payload) => ({
    type: "REPORTS/GET_FACILITY_PATIENT_HISTORY_REPORT",
    payload,
  }),
  getIncidentReport: (payload) => ({
    type: "REPORTS/GET_INCIDENT_REPORT",
    payload,
  }),
  getUsageReport: (payload) => ({
    type: "REPORTS/GET_USAGE_REPORT",
    payload,
  }),
  getDailyOrdersReport: (payload) => ({
    type: "REPORTS/GET_DAILY_ORDERS_REPORT",
    payload,
  }),
  getEmsDailyReport: (payload) => ({
    type: "REPORTS/GET_EMS_DAILY_REPORT",
    payload,
  }),
  getIcdReport: (payload) => ({
    type: "REPORTS/GET_ICD_REPORT",
    payload,
  }),
  getProviderPatientLog: (payload) => ({
    type: "REPORTS/GET_PROVIDER_PATIENT_LOG",
    payload,
  }),
};

function* getInventoryReportAsync(action) {
  try {
    yield put(showLoader());
    const response = yield ReportsService.getInventoryReport(action?.payload);
    const { status, data } = response;
    if (status) {
      yield put(setInventoryReport(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setInventoryReport({}));
  } finally {
    yield put(hideLoader());
  }
}

function* getIncidentReportAsync(action) {
  try {
    yield put(showLoader());
    const response = yield ReportsService.getIncidentReport(action?.payload);
    const { status, data } = response;
    if (status) {
      yield put(setIncidentReport(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setIncidentReport({}));
  } finally {
    yield put(hideLoader());
  }
}

function* getUsageReportAsync(action) {
  try {
    yield put(showLoader());
    const response = yield ReportsService.getUsageReport(action?.payload);
    const { status, data } = response;
    if (status) {
      yield put(setUsageReport(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setUsageReport({}));
  } finally {
    yield put(hideLoader());
  }
}

function* getDailyOrdersReportAsync(action) {
  try {
    yield put(showLoader());
    const response = yield ReportsService.getDailyOrdersReport(action?.payload);
    const { status, data } = response;
    if (status) {
      yield put(setDailyOrdersReport(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setDailyOrdersReport({}));
  } finally {
    yield put(hideLoader());
  }
}

function* getEmsDailyReportAsync(action) {
  try {
    yield put(showLoader());
    const response = yield ReportsService.getEmsDailyReport(action?.payload);
    const { status, data } = response;
    if (status) {
      yield put(setEmsDailyReport(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setEmsDailyReport({}));
  } finally {
    yield put(hideLoader());
  }
}

function* getFacilityPatientHistoryReportAsync(action) {
  try {
    yield put(showLoader());
    const response = yield ReportsService.getFacilityPatientHistory(
      action?.payload,
    );
    const { status, data } = response;
    if (status) {
      yield put(setFacilityPatientHistoryReport(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setFacilityPatientHistoryReport({}));
  } finally {
    yield put(hideLoader());
  }
}

function* getIcdReportAsync(action) {
  try {
    yield put(showLoader());
    const response = yield ReportsService.getIcdReport(action?.payload);
    const { status, data } = response;
    if (status) {
      yield put(setIcdReport(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setIcdReport({}));
  } finally {
    yield put(hideLoader());
  }
}

function* getProviderPatientLogAsync(action) {
  try {
    yield put(showLoader());
    const response = yield ReportsService.getProviderPatientLog(
      action?.payload,
    );
    const { status, data } = response;
    if (status) {
      yield put(setProviderPatientLog(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setProviderPatientLog({}));
  } finally {
    yield put(hideLoader());
  }
}

function* rootSaga() {
  yield all([
    takeLatest(getInventoryReport().type, getInventoryReportAsync),
    takeLatest(getIncidentReport().type, getIncidentReportAsync),
    takeLatest(getUsageReport().type, getUsageReportAsync),
    takeLatest(getDailyOrdersReport().type, getDailyOrdersReportAsync),
    takeLatest(getEmsDailyReport().type, getEmsDailyReportAsync),
    takeLatest(
      getFacilityPatientHistoryReport().type,
      getFacilityPatientHistoryReportAsync,
    ),
    takeLatest(getIcdReport().type, getIcdReportAsync),
    takeLatest(getProviderPatientLog().type, getProviderPatientLogAsync),
  ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);
